import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Accordion extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    singleExpand: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    singleExpand: false,
  };

  constructor(props) {
    super(props);
    this.state = { openElements: new Set(this.getInitialExpanded()) };
  }

  getInitialExpanded = () => {
    const { children } = this.props;

    if (children) {
      return React.Children
        .map(children, (el, index) => {
          if (el && el.props && el.props.expanded) {
            return index;
          }

          return false;
        })
        .filter(index => index !== false);
    }

    return [];
  };

  onElementToggle = (childIndex, e) => {
    e.preventDefault();
    if (this.props.singleExpand) {
      this.toggleElementAndCollapseOthers(childIndex);
    } else {
      this.toggleElement(childIndex);
    }
  };

  toggleElement = (childIndex) => {
    this.setState(prevState => {
      const openElements = new Set(prevState.openElements);
      if (openElements.has(childIndex)) {
        openElements.delete(childIndex);
      } else {
        openElements.add(childIndex);
      }
      return { openElements };
    });
  };

  toggleElementAndCollapseOthers = (childIndex) => {
    this.setState(prevState => {
      if (prevState.openElements.has(childIndex)) {
        return { openElements: new Set() };
      } else {
        return { openElements: new Set([childIndex]) };
      }
    });
  };

  render = () => {
    const { children, className } = this.props;
    if (!children) {
      return null;
    }

    const accordionElements = React.Children.map(children, (el, index) => {
      if (!el || !el.props) {
        return null;
      }

      const extraParams = {
        onElementClick: this.onElementToggle,
        index,
        expanded: this.state.openElements.has(index),
      };
      return React.cloneElement(el, extraParams);
    });

    return (
      <div className={`${className} gn-accordion`}>
        {accordionElements}
      </div>
    );
  }
}
